import { render } from "./CustomerAndOrderNotesDetails.vue?vue&type=template&id=aad2e45e"
import script from "./CustomerAndOrderNotesDetails.vue?vue&type=script&lang=js"
export * from "./CustomerAndOrderNotesDetails.vue?vue&type=script&lang=js"

import "./CustomerAndOrderNotesDetails.vue?vue&type=style&index=0&id=aad2e45e&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__